import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import { ENDPOINTS } from '../../../../shared/organizationPackages/helpers';
import type { PackageInventoryQueryParams } from '../../../helpers/packageInventory';
import type { FetchPackageMetadataResponse } from '../../../../shared/organizationPackages/response';

const fetchPackageMetadata = (locator: string, params: PackageInventoryQueryParams) =>
  get<FetchPackageMetadataResponse>(`${ENDPOINTS.FETCH_PACKAGES}/${nuc(locator)}`, true, params, {
    encodeQuery: true,
  });

export const getPackageMetadataQueryKey = (locator: string | undefined, params: PackageInventoryQueryParams) =>
  ['packages', locator, 'metadata', params] as const;

export default function usePackageMetadata(locator: string | undefined, params: PackageInventoryQueryParams) {
  return useQuery<FetchPackageMetadataResponse>({
    queryKey: getPackageMetadataQueryKey(locator, params),
    queryFn: () => {
      if (!locator) {
        throw new Error('A package locator is required to fetch package metadata.');
      }
      return fetchPackageMetadata(locator, params);
    },
    enabled: !!locator,
    staleTime: 1000 * 60 * 5,
  });
}
